(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["articles-recents-tous-blogs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBlogIntro = () => {
      document.querySelectorAll('.shopify-section--latest-blog-articles').forEach((sectionWrapper, index) => {
        const latestArticles = sectionWrapper.querySelector('.latest-blog-articles');
        const introSection = sectionWrapper.previousElementSibling;

        if (
          !latestArticles ||
          !introSection ||
          !introSection.classList.contains('shopify-section--main-page') ||
          introSection.classList.contains('blog-intro--enhanced')
        ) {
          return;
        }

        const stack = introSection.querySelector('.section-stack');

        if (!stack) {
          return;
        }

        const content = Array.from(stack.children).find(
          (element) => !element.classList.contains('section-header')
        );

        if (!content) {
          return;
        }

        const body = document.createElement('div');
        const button = document.createElement('button');
        const contentId = `blog-intro-content-${sectionWrapper.id || index}`;
        const readMoreLabel = latestArticles.dataset.introReadMore || 'Lire la suite';
        const readLessLabel = latestArticles.dataset.introReadLess || 'Réduire';
        let resizeTimeout;

        body.className = 'blog-intro__body';
        content.classList.add('blog-intro__content');
        content.id = contentId;

        button.type = 'button';
        button.className = 'blog-intro__toggle';
        button.setAttribute('aria-controls', contentId);
        button.setAttribute('aria-expanded', 'false');
        button.textContent = readMoreLabel;
        button.hidden = true;

        content.before(body);
        body.append(content, button);
        introSection.classList.add('blog-intro--enhanced', 'blog-intro--collapsed');

        const updateButtonVisibility = () => {
          if (!introSection.classList.contains('blog-intro--collapsed')) {
            return;
          }

          const overflow = content.scrollHeight - content.clientHeight;
          const lineHeight = Number.parseFloat(window.getComputedStyle(content).lineHeight) || 0;
          const overflowTolerance = Math.max(2, lineHeight * 0.2);

          button.hidden = overflow <= overflowTolerance;
        };

        button.addEventListener('click', () => {
          const isExpanded = button.getAttribute('aria-expanded') === 'true';

          button.setAttribute('aria-expanded', String(!isExpanded));
          button.textContent = isExpanded ? readMoreLabel : readLessLabel;
          introSection.classList.toggle('blog-intro--collapsed', isExpanded);

          if (isExpanded) {
            requestAnimationFrame(updateButtonVisibility);
          }
        });

        window.addEventListener('resize', () => {
          if (!introSection.classList.contains('blog-intro--collapsed')) {
            return;
          }

          window.clearTimeout(resizeTimeout);
          resizeTimeout = window.setTimeout(updateButtonVisibility, 150);
        }, { passive: true });

        requestAnimationFrame(updateButtonVisibility);

        if (document.fonts?.ready) {
          document.fonts.ready.then(updateButtonVisibility);
        }
      });
    };

    initBlogIntro();
    document.addEventListener('shopify:section:load', initBlogIntro);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-choice-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChoiceGuide = () => {
      document.querySelectorAll('[data-choice-guide]').forEach((root) => {
        if (root.dataset.enhanced === 'true') {
          return;
        }

        const content = root.querySelector('[data-guide-content]');
        const toc = root.querySelector('[data-guide-toc]');

        if (!content || !toc) {
          return;
        }

        root.dataset.enhanced = 'true';

        const headings = Array.from(content.querySelectorAll(':scope > h2'));

        headings.forEach((heading, index) => {
          heading.id = heading.id || `guide-section-${index + 1}`;

          const item = document.createElement('li');
          const link = document.createElement('a');

          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          item.append(link);
          toc.append(item);
        });

        content.querySelectorAll('table').forEach((table) => {
          const columnLabels = Array.from(table.querySelectorAll('thead th')).map((heading) => heading.textContent.trim());

          table.querySelectorAll('tbody tr').forEach((row) => {
            Array.from(row.querySelectorAll('td')).forEach((cell, index) => {
              cell.dataset.label = columnLabels[index] || '';
            });
          });

          if (!table.parentElement.matches('.choice-guide__table-wrap, .table-scroller')) {
            const wrapper = document.createElement('div');
            wrapper.className = 'choice-guide__table-wrap';
            table.before(wrapper);
            wrapper.append(table);
          }
        });

        const productHeadings = Array.from(content.querySelectorAll(':scope > h3')).filter((heading) => {
          return heading.querySelector('a[href*="/products/"]');
        });

        if (productHeadings.length > 0) {
          const grid = document.createElement('div');
          grid.className = 'choice-guide__product-grid';
          productHeadings[0].before(grid);

          productHeadings.forEach((heading) => {
            const description = heading.nextElementSibling;
            const card = document.createElement('article');
            card.className = 'choice-guide__product-card';
            card.append(heading);

            if (description?.tagName === 'P') {
              card.append(description);
            }

            grid.append(card);
          });
        }

        if ('IntersectionObserver' in window && headings.length > 0) {
          const links = Array.from(toc.querySelectorAll('a'));
          const observer = new IntersectionObserver((entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

            if (!visible) {
              return;
            }

            links.forEach((link) => {
              link.removeAttribute('aria-current');
            });

            const active = toc.querySelector(`a[href="#${visible.target.id}"]`);
            active?.setAttribute('aria-current', 'true');
          }, {
            rootMargin: '-18% 0px -68% 0px',
            threshold: 0
          });

          headings.forEach((heading) => observer.observe(heading));
        }
      });
    };

    initChoiceGuide();
    document.addEventListener('shopify:section:load', initChoiceGuide);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChoiceGuide = () => {
      document.querySelectorAll('[data-choice-guide]').forEach((root) => {
        if (root.dataset.enhanced === 'true') {
          return;
        }

        const content = root.querySelector('[data-guide-content]');
        const toc = root.querySelector('[data-guide-toc]');

        if (!content || !toc) {
          return;
        }

        root.dataset.enhanced = 'true';

        const headings = Array.from(content.querySelectorAll(':scope > h2'));

        headings.forEach((heading, index) => {
          heading.id = heading.id || `guide-section-${index + 1}`;

          const item = document.createElement('li');
          const link = document.createElement('a');

          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          item.append(link);
          toc.append(item);
        });

        content.querySelectorAll('table').forEach((table) => {
          const columnLabels = Array.from(table.querySelectorAll('thead th')).map((heading) => heading.textContent.trim());

          table.querySelectorAll('tbody tr').forEach((row) => {
            Array.from(row.querySelectorAll('td')).forEach((cell, index) => {
              cell.dataset.label = columnLabels[index] || '';
            });
          });

          if (!table.parentElement.matches('.choice-guide__table-wrap, .table-scroller')) {
            const wrapper = document.createElement('div');
            wrapper.className = 'choice-guide__table-wrap';
            table.before(wrapper);
            wrapper.append(table);
          }
        });

        const productHeadings = Array.from(content.querySelectorAll(':scope > h3')).filter((heading) => {
          return heading.querySelector('a[href*="/products/"]');
        });

        if (productHeadings.length > 0) {
          const grid = document.createElement('div');
          grid.className = 'choice-guide__product-grid';
          productHeadings[0].before(grid);

          productHeadings.forEach((heading) => {
            const description = heading.nextElementSibling;
            const card = document.createElement('article');
            card.className = 'choice-guide__product-card';
            card.append(heading);

            if (description?.tagName === 'P') {
              card.append(description);
            }

            grid.append(card);
          });
        }

        if (root.closest('.article--e-liquid-guide')) {
          const firstSection = content.querySelector(':scope > h2');
          const nextSection = firstSection?.nextElementSibling;
          const criteria = [];
          let candidate = nextSection;

          while (candidate && candidate.tagName !== 'H2') {
            if (candidate.tagName === 'H3' && candidate.nextElementSibling?.tagName === 'P') {
              criteria.push([candidate, candidate.nextElementSibling]);
            }

            candidate = candidate.nextElementSibling;
          }

          if (criteria.length > 0) {
            const criteriaGrid = document.createElement('div');
            criteriaGrid.className = 'choice-guide__criteria-grid';
            criteria[0][0].before(criteriaGrid);

            criteria.forEach(([heading, paragraph]) => {
              const criterion = document.createElement('article');
              criterion.className = 'choice-guide__criterion';
              criterion.append(heading, paragraph);
              criteriaGrid.append(criterion);
            });
          }
        }

        if ('IntersectionObserver' in window && headings.length > 0) {
          const links = Array.from(toc.querySelectorAll('a'));
          const observer = new IntersectionObserver((entries) => {
            const visible = entries
              .filter((entry) => entry.isIntersecting)
              .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

            if (!visible) {
              return;
            }

            links.forEach((link) => {
              link.removeAttribute('aria-current');
            });

            const active = toc.querySelector(`a[href="#${visible.target.id}"]`);
            active?.setAttribute('aria-current', 'true');
          }, {
            rootMargin: '-18% 0px -68% 0px',
            threshold: 0
          });

          headings.forEach((heading) => observer.observe(heading));
        }
      });
    };

    initChoiceGuide();
    document.addEventListener('shopify:section:load', initChoiceGuide);
  })();

  } catch(e) { console.error(e); }
})();
})();
